var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 113,
    viewBox: "0 0 129 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9639 0C85.5174 0 78.6981 2.31797 72.6945 6.88868C69.665 9.19599 66.9203 12.0188 64.5 15.3134C62.081 12.0198 59.335 9.19599 56.3047 6.88868C50.3022 2.31797 43.4826 0 36.0364 0C26.0741 0 16.9103 3.92746 10.2326 11.0585C3.63468 18.1062 0 27.7346 0 38.1709C0 48.9126 4.06577 58.7452 12.7944 69.1158C20.6032 78.3924 31.826 87.8094 44.8222 98.7138C49.2599 102.438 54.2901 106.659 59.5131 111.155C60.893 112.345 62.6635 113 64.5 113C66.3355 113 68.1072 112.345 69.4849 111.157C74.7081 106.66 79.7411 102.437 84.1808 98.7109C97.1753 87.8084 108.398 78.3924 116.207 69.1148C124.935 58.7452 129 48.9126 129 38.1699C129 27.7346 125.365 18.1062 118.766 11.0585C112.089 3.92746 102.926 0 92.9639 0Z",
    fill: "#EDB111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1202_5400",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 113
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9639 0C85.5174 0 78.6981 2.31797 72.6945 6.88868C69.665 9.19599 66.9203 12.0188 64.5 15.3134C62.081 12.0198 59.335 9.19599 56.3047 6.88868C50.3022 2.31797 43.4826 0 36.0364 0C26.0741 0 16.9103 3.92746 10.2326 11.0585C3.63468 18.1062 0 27.7346 0 38.1709C0 48.9126 4.06577 58.7452 12.7944 69.1158C20.6032 78.3924 31.826 87.8094 44.8222 98.7138C49.2599 102.438 54.2901 106.659 59.5131 111.155C60.893 112.345 62.6635 113 64.5 113C66.3355 113 68.1072 112.345 69.4849 111.157C74.7081 106.66 79.7411 102.437 84.1808 98.7109C97.1753 87.8084 108.398 78.3924 116.207 69.1148C124.935 58.7452 129 48.9126 129 38.1699C129 27.7346 125.365 18.1062 118.766 11.0585C112.089 3.92746 102.926 0 92.9639 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1202_5400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 25,
    r: 58.5,
    fill: "#DA0A61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 76,
    r: 36.5,
    fill: "#B60072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesLogo);
export default __webpack_public_path__ + "static/media/likesLogo.9b535436992a77c656dbff391d11b875.svg";
export { ForwardRef as ReactComponent };